import React, { useEffect, useState } from 'react';
import { ClockIcon } from 'lucide-react';
const TOTAL_SECONDS = 17 * 60 + 34;
function pad(n: number) {
  return n.toString().padStart(2, '0');
}
export function CountdownTimer() {
  const [remaining, setRemaining] = useState(TOTAL_SECONDS);
  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining(prev => prev <= 1 ? TOTAL_SECONDS : prev - 1);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor(remaining % 3600 / 60);
  const seconds = remaining % 60;
  const blocks = [{
    value: pad(hours),
    label: 'HORAS'
  }, {
    value: pad(minutes),
    label: 'MIN'
  }, {
    value: pad(seconds),
    label: 'SEG'
  }];
  return <div className="mt-6 w-full max-w-md rounded-2xl border border-brandred/25 bg-brandred/5 px-4 py-4" data-id="element-17" data-mp="15g0mfo8zpts1">
      <p className="flex items-center justify-center gap-2 text-center text-[11px] sm:text-xs font-extrabold uppercase tracking-widest text-brandred" data-id="element-18" data-mp="34oe5ildubw4x">
        <ClockIcon className="h-4 w-4" strokeWidth={2.5} data-id="element-19" data-mp="1bzvpo01dzwi3" />
        Esta oferta expira en
      </p>
      <div className="mt-3 flex items-start justify-center gap-2 sm:gap-3" role="timer" aria-live="off" data-id="element-20" data-mp="1h0t90fy4uwl6">
        {blocks.map((b, i) => <React.Fragment key={b.label} data-id="element-21" data-mp="1712a822jhvfa" data-mpi={i}>
            <div className="flex w-[74px] sm:w-20 flex-col items-center rounded-xl bg-navy px-2 py-2.5" data-id="element-22" data-mp="1723xd4wty8dd">
              <span className="font-display text-3xl sm:text-4xl font-black tabular-nums text-white" data-id="element-23" data-mp="1urya7mh5fwxm">
                {b.value}
              </span>
              <span className="mt-0.5 text-[9px] font-bold tracking-[0.15em] text-white/60" data-id="element-24" data-mp="1l1wm4uosqeip">
                {b.label}
              </span>
            </div>
            {i < blocks.length - 1 && <span className="pt-2 font-display text-2xl sm:text-3xl font-black text-navy/30" data-id="element-25" data-mp="2dpiojzmafd3z">
                :
              </span>}
          </React.Fragment>)}
      </div>
    </div>;
}